<template>
  <div class="chart_warp">
    <div class="chart_tool">
      <el-button class="def_btn tool_icon_btn" plain size="small" icon="el-icon-full-screen" :disabled="showEmpty"
        @click="fullScreen">
      </el-button>
      <el-button v-if="false" class="def_btn" plain size="small" @click="exportData">
        <span class="btn_txt">导出数据</span>
        <span class="btn_icon">
          <img :src="require('@/assets/export.png')" alt="">
        </span>
      </el-button>
    </div>
    <div class="chart_cont" :ref="'graph_' + chartName"></div>
    <div class="empty_tips" v-if="showEmpty">暂无数据</div>
    <!-- 全屏显示图表 -->
    <el-dialog :title="dialogTitle" custom-class="big_dialog" top="0" :visible.sync="fullVisible" width="100%">
      <div class="chart_cont" :ref="'full_graph_' + chartName" v-show="!showOwn"></div>
      <OwnGraphChart :ref="'own_graph_' + chartName" v-if="showOwn" :detailType="detailType"
        :centerId="centerId" :nodeNum="nodeNum" :chartInfo="ownChartInfo" @closeOwn="closeOwnGraph"
        @setRestaurants="setRestaurants" @setResultsList="setResultsList" @changeChart="changeChart">
      </OwnGraphChart>
      <div class="chart_tool" v-if="!showEmpty">
        <div class="filter_labels">
          <div class="label_title">一级图例：</div>
          <div class="label_item" v-for="(item, i) in labels" :class="{ line: item.icon == 'line', active: item.show }">
            <span class="item_icon" :class="[item.icon, item.type ? 'bg' + item.type : '']"
              :style="{ background: item.itemStyle && item.itemStyle.color, borderColor: item.itemStyle && item.itemStyle.borderColor }">
            </span>
            <span class="item_label" @click="changeChart(item)">{{ item.label }}</span>
          </div>
        </div>
        <div class="filter_btn" v-show="toShowFilter" @click="toShowFilter = false">
          <i class="el-icon-d-arrow-left"></i>
        </div>
        <div class="filter_panel" :class="{ active: !toShowFilter }">
          <div class="filter_btn">
            <span>筛选</span>
            <i class="el-icon-d-arrow-right" @click="toShowFilter = true"></i>
          </div>
          <div class="filter_bars">
            <div class="bar_item">
              <span class="item_label">文字显示：</span>
              <el-switch v-model="textAct" :width="32" :active-text="textAct ? '显示' : '隐藏'" active-color="#4FA1A4"
                inactive-color="#B2B2B2" @change="changeChart('linksLabel')"></el-switch>
            </div>
            <div class="bar_item">
              <span class="item_label">单独显示节点规则：</span>
              <div class="bar_text">
                <span class="text_txt">超过</span>
                <el-input class="text_num" size="mini" placeholder="数量" v-model="nodeNum"></el-input>
                <span class="text_txt">个节点</span>
              </div>
            </div>
          </div>
          <!-- 搜索聚焦 -->
          <el-input class="inline-input" v-model="filterKeyword" clearable placeholder="输入关键字聚焦相关关系" size="small"
            @change="querySearch" @clear="changeChart('clear')">
            <template slot="append">
              <div class="auto_btn" :class="{ active: selectIndex != '' }" @click="changeChart()">
                {{ focusText }}
              </div>
            </template>
          </el-input>
          <!-- 筛选列表 -->
          <div class="filter_list">
            <div class="list_item" :class="{ active: ('focus_' + i) == selectIndex }" v-for="(item, i) in resultsList"
              @click="selectIndex = 'focus_' + i; chartSelect(item)">
              {{ item.nodeName }}
            </div>
          </div>
          <!-- 确定/重置 -->
          <div class="filter_btns">
            <div class="btn_item" @click="changeChart('reset')">重置</div>
            <div class="btn_item sure_btn" @click="changeChart('maxNum')">确定</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getFormatter, getNodeByEdge, getNodeEdge, deepClone } from '@/api/portrait.js'
import { nodeStyle } from '@/uilt/linkage.js'
// import * as echarts from '@/assets/js/echarts.min.js'
import OwnGraphChart from './ownGraphChart.vue'

export default {
  components: {
    OwnGraphChart,
  },
  props: {
  },
  data() {
    return {
      myChart: null,
      fullVisible: false,
      chartName: '',
      dialogTitle: '关系网',
      showEmpty: false,
      option: {
        // tooltip: {
        //     formatter: ''
        // },
        series: [
          {
            type: 'graph',
            id: 'graph1',
            z: 1,
            center: ['50%', '50%'],
            label: {
              show: true,
              color: '#fff',
              fontSize: 12,
            },
            edgeLabel: {
              show: false
            },
            itemStyle: {
              borderWidth: 1
            },
            lineStyle: {
              color: '#b2ebf2',
              opacity: 1,
              width: 2,
              curveness: 0 // 连线曲率
            },
            emphasis: {
              focus: 'adjacency',
              blurScope: 'series',
              scale: false
            },
            blur: {
              itemStyle: {
                color: '#f5f5f5',
                borderColor: '#e6e6e6',
                opacity: 1
              },
              lineStyle: {
                opacity: 0.1,
                color: '#e6e6e6'
              },
            },
            layout: 'force',
            symbol: 'circle',
            focusNodeAdjacency: true,
            nodeScaleRatio: 0.1,
            scaleLimit: {
              min: 2,
              max: 10
            },
            force: {
              gravity: 0.3,
              repulsion: 40,
              layoutAnimation: false,
              friction: 0.1,
              // edgeLength: [30, 60]
            },
            data: [],
            links: [],
            animationDuration: 0,
            animationDurationUpdate: 0
          }
        ],
        animation: false
      },
      labels: [],
      labelsNodes: {},
      toShowFilter: true,
      filterKeyword: '',
      resultsList: [],
      restaurants: [],
      selectIndex: '',
      focusText: '聚焦',
      toFocus: true,
      textAct: false,
      nodeNum: '10',
      currNode: null,
      tabsVisible: false,
      tabsNodeIndex: null,
      detailType: '',
      selectNodes: null,
      selectIndexs: null,
      centerId: '',
      isFocus: false,
      drag: false,
      showOwn: false, //单独显示
      ownChartInfo: {},
      roamInfo: null,
      prevZoom: null,
      pieOver: false,
      optionMap: {}
    }
  },
  beforeDestroy() {
    this.myChart && this.myChart.clear();
  },
  methods: {
    setOption(val) {
      let nodes = val.nodes == null ? [] : val.nodes[0] ? val.nodes : []
      if (nodes.length == 0) {
        this.showEmpty = true;
        return;
      }
      this.detailType = this.chartName.split('-')[0]
      let type = this.chartName.split('-')[1]
      if (this.detailType == '1') {
        this.dialogTitle = type == '1' ? '人员关系网' : type == '2' ? '终端服务关系网' : '渠道人员关系网'
      } else if (this.detailType == '2') {
        this.dialogTitle = type == '4' ? '终端服务关系网' : type == '5' ? '终端配送关系网' : '渠道配送关系网'
      } else if (this.detailType == '3') {
        this.dialogTitle = type == '7' ? '销售流向关系网' : type == '8' ? '终端采购关系网' : '渠道采购关系网'
      }
      // 设置标签
      let tabs = nodes[0].relations
      this.setTabs(tabs, type)
      // 设置节点
      let datas = this.setDataItem(nodes)
      this.option.series[0].data = datas
      this.setRestaurants(nodes)
      this.$nextTick(() => {
        this.fullVisible ? this.loadChart('full_graph_' + this.chartName) : this.loadChart('graph_' + this.chartName)
      })
    },
    loadChart(chartId, init = true) {
      if (this.showEmpty) return
      if (init) {
        let chartDom = this.$refs[chartId];
        this.myChart = echarts.init(chartDom);
        this.option.series[0].roam = this.fullVisible
        this.option.series[0].zoom = this.fullVisible ? 6 : this.detailType == '1' ? 4 : 5
        // this.option.series[0].draggable = this.fullVisible
      }
      // console.log(this.optionMap)

      if (!init) {
        this.myChart.setOption(this.option);
        // 设置高亮点
        let dataIndex = this.selectIndexs ? this.selectIndexs : []
        if (dataIndex.length) {
          this.myChart.dispatchAction({
            type: 'highlight',
            seriesIndex: 0,
            dataIndex: dataIndex
          });
        } else {
          this.myChart.dispatchAction({
            type: 'downplay',
            seriesIndex: 0
          });
        }
        if (this.isFocus || this.tabsVisible) {
          this.option.series[0].emphasis.disabled = true
        } else {
          this.option.series[0].emphasis.disabled = false
        }
        // 设置视图中心点 防止缩放后点击 数据看不见
        this.option.series[0].center = ['50%', '50%']
        if (this.roamInfo) {
          this.option.series[0].zoom = this.roamInfo.zoom
          this.option.series[0].center = this.roamInfo.center
        }
      }
      this.myChart.setOption(this.option);
      // 固定点位
      // this.getPieSeries(true)

      // 事件监听
      if (init && this.fullVisible) {
        this.myChart.off('mouseover')
        this.myChart.on('mouseover', (e) => {
          this.pieOver = true
          // console.log(e)
          // e.event.target.cursor = 'pointer'
        })

        this.myChart.off('mouseup')
        this.myChart.on('mouseup', (params) => {
          // console.log(params)
          // if (params.componentSubType == "graph" && params.dataType == "edge") {
          //     var option = _this.myChart.getOption();
          //     option.series[0].data[params.dataIndex].x = params.event.offsetX;
          //     option.series[0].data[params.dataIndex].y = params.event.offsetY;
          //     option.series[0].data[params.dataIndex].fixed = true;
          //     this.myChart.setOption(option);
          // }
        });

        this.myChart.off('click')
        this.myChart.on('click', (params) => {
          // this.drag = false
          if (!this.isFocus) {
            if (params.seriesType === "graph") {
              if (params.dataType === "node") {
                this.tabsNodeIndex = params.dataIndex
                this.tabsVisible && this.closeTabs()
                this.$emit('openLoading', true)
                this.getTabs(params, 'node')
              }
            } else if (params.seriesType === "pie") {
              this.tabsNodeIndex = null
              this.tabsVisible && this.closeTabs()
              if (Number(params.data.cnt) > 100) {
                this.$message('请在详情列表中查看此类数据');
                return
              }
              this.setNodes(params)
            }
          }
        });

        this.myChart.off('graphRoam')
        this.myChart.on('graphRoam', (e) => {
          const zoom = this.myChart._coordSysMgr._coordinateSystems[0]._zoom;
          const center = this.myChart._coordSysMgr._coordinateSystems[0]._center;
          this.prevZoom = this.roamInfo ? this.roamInfo.zoom : 6
          this.roamInfo = { center, zoom }
          // this.drag = true
          if (this.tabsVisible) {
            this.tabsNodeIndex = null
            this.closeTabs()
          }

        })

        this.myChart.off('finished')
        this.myChart.on('finished', (e) => {
          if (this.tabsVisible && !this.pieOver) {
            setTimeout(() => {
              let series = this.getPieSeries()
              this.myChart.setOption({
                series: series
              });
            }, 100)
          }
        });

        let Zr = this.myChart.getZr()
        Zr.on('click', (params) => {
          this.pieOver = false
          if (this.isFocus) {
            this.changeChart('deFocus')
          }
        })
      }
    },
    // 根据关系图的各节点信息得到饼图数据
    getPieSeries(fixed = false) {
      let chart = this.myChart
      const modal = chart.getModel().getSeriesByIndex(0);
      const info = modal.getData();
      const itemLayouts = info._itemLayouts
      const itemVisuals = info._itemVisuals
      const s = this.prevZoom ? this.prevZoom : 6
      if (fixed) {
        let datas = [...this.option.series[0].data]
        datas = datas.map((item, index) => {
          item.x = itemLayouts[index][0]
          item.y = itemLayouts[index][1]
          item.fixed = true
          return item
        })
        this.option.series[0].data = datas
        this.myChart.setOption(this.option)
      } else {
        let index = this.tabsNodeIndex, data = this.option.series[0].data[index], series = []
        if (itemLayouts[index]) {
          let x = itemLayouts[index][0]
          let y = itemLayouts[index][1]
          let r = itemVisuals[index].symbolSize * ((z / s).toFixed(2))
          // convertToPixel()方法的两个参数：第一个参数用来指定坐标系，第二个参数用来指定某个点
          var center = chart.convertToPixel({
            seriesIndex: 0
          }, [x, y]);
          // 饼图
          let pie = {
            type: 'pie',
            name: 'graphPie',
            id: 'graph1-s_' + index,
            radius: [r, r + 40],
            center: center,
            z: 2,
            avoidLabelOverlap: false,
            selectedMode: 'multiple',
            selectedOffset: 0,
            showEmptyCircle: false,
            minAngle: 30,
            itemStyle: {
              borderRadius: [0, 10],
            },
            label: {
              position: 'inside',
              color: '#fff',
              fontSize: 12,
              lineHeight: 14,
              formatter: (params) => getFormatter(params.name, 4)
            },
            data: data.showTab ? data.tabs : [],
            animationDuration: 100,
            animationDurationUpdate: 0,
            animation: false
          }

          if (data.showTab) {
            series.push(pie)
          }
        }
        return series
      }
    },
    setDataItem(data, opt) {
      let datas = [], dT = this.detailType, _this = this
      // 设置节点数据
      data.map((item, i) => {
        if (!opt || (opt && opt.name != item.name)) {
          let name = item.nodeName
          item.tooltip = {
            formatter: (params) => {
              return name
            }
          }
          // 计算文字长度 将中文转换为两个字节的英文再计算
          let len = name.replace(/[\u0391-\uFFE5]/g, 'aa').length

          if (item.isCenter == 1) {
            item.symbolSize = 80
            let n = dT == '1' ? 6 : 12
            item.label = {
              fontSize: dT == '1' ? 24 : 16,
              lineHeight: dT == '1' ? 24 : 18,
              formatter: (params) => {// 设置每6个字符长度换行 中文对应2个字符长度
                let val = name
                if (len > n * 3) {
                  let nv = name.slice(0, n * 1.5 - 2)
                  val = `${getFormatter(nv, n)}...`
                } else {
                  val = getFormatter(name, n)
                }
                return val
              },
            }
            item.itemStyle = {
              color: '#4162E8',
              borderColor: "#4162E8",
              borderWidth: 1,
            }
            if (!opt) {
              this.showEmpty = item.relations.length ? false : true
              this.centerId = item.properties.id_card
            }
          } else {
            item.label = {
              fontSize: 14,
              lineHeight: 16,
              formatter: getFormatter(name, 6),
            }
            const tab = this.currNode.name
            nodeStyle.map(node => {
              if (node.tab == tab) {
                item.type = node.type
                item.tab = node.tab
                item.itemStyle = { ...node.itemStyle }
                item.colors = [node.itemStyle.color, node.itemStyle.borderColor]
                item.label = {
                  fontSize: 14,
                  lineHeight: 16,
                  color: node.itemStyle.borderColor,
                  formatter: (params) => {
                    let val = name
                    if (len > node.lineWords * 3) {
                      let nv = name.slice(0, node.lineWords * 1.5 - 2)
                      val = `${getFormatter(nv, node.lineWords)}...`
                    } else {
                      val = getFormatter(name, node.lineWords)
                    }
                    return val
                  }
                }
                // 计算文字行数
                let rows = Math.ceil(len / node.lineWords)
                let r = rows > 3 ? 3 : rows
                let l = (node.lineWords / 2) * 14
                item.symbolSize = Math.sqrt(Math.pow(0.5 * l + 20, 2) + Math.pow(8 * r, 2))
                item.emphasis = {
                  itemStyle: {
                    color: node.itemStyle.borderColor
                  },
                  label: {
                    color: '#fff'
                  }
                }
                item.bright = { ...node.itemStyle }
                let nodeType = ''
                if (node.type.indexOf('1-') > -1) {
                  nodeType = '1'
                } else if (node.type.indexOf('2-') > -1) {
                  nodeType = '2'
                } else if (node.type.indexOf('4-') > -1) {
                  nodeType = '4'
                } else if (node.type.indexOf('5-') > -1) {
                  nodeType = '5'
                }
                _this.setLabelsNodes(nodeType, item)
              }
            })
          }
          _this.optionMap[item.name] = item
          if (this.showOwn) {
            datas.push(item)
          } else {
            let isExist = false, optData = [...this.option.series[0].data]
            optData.map(dt => {
              if (dt.name == item.name) {
                isExist = true
              }
            })
            !isExist && datas.push(item)
          }
        }
      })
      return datas
    },
    setLabelsNodes(type, data) {
      if (this.showOwn) {
        if (this.ownChartInfo.labelsNodes['data' + type]) {
          let nodeExist = false
          this.ownChartInfo.labelsNodes['data' + type].map(nd => {
            if (nd.name == data.name) {
              nodeExist = true
            }
          })
          !nodeExist && this.ownChartInfo.labelsNodes['data' + type].push(data)
        }
      } else {
        if (this.labelsNodes['data' + type]) {
          let nodeExist = false
          this.labelsNodes['data' + type].map(nd => {
            if (nd.name == data.name) {
              nodeExist = true
            }
          })
          !nodeExist && this.labelsNodes['data' + type].push(data)
        }
      }
    },
    // 关闭tabs
    closeTabs() {
      this.tabsVisible = false
      let datas = this.option.series[0].data, index = this.tabsNodeIndex
      datas = datas.map((item, i) => {
        if (item.tabs && i != index) {
          item.showTab = false
        }
        return item
      })
      this.option.series[0].data = datas
      this.option.series.splice(1)
      let option = this.myChart.getOption()
      let series = option.series.slice(1)
      series = series.map(s => {
        s.data = []
        return s
      })
      this.myChart.setOption({
        series: series
      })
    },
    setTabs(params, type) {
      if (type == 'node') {
        let nodes = []
        let tabs = params.relations || params
        tabs.map((item, i) => {
          item.value = 10
          item.itemStyle = {
            color: '#B1B1B1'
          }
          nodeStyle.map(node => {
            if (node.tab == item.name) {
              item.color = node.itemStyle.borderColor
            }
          })
          item.emphasis = {
            itemStyle: {
              color: item.color
            },
          }
          item.select = {
            itemStyle: {
              color: item.color
            },
          }
          item.tooltip = {
            formatter: item.name + '-' + item.cnt
          }
          nodes.push(item);
        })
        return nodes
      } else {
        let tabs = params
        this.labels = []
        tabs.map(item => {
          let name = item.name
          let label = {
            label: name,
            icon: 'circle',
          }
          nodeStyle.map(node => {
            if (node.tab == name) {
              label.itemStyle = node.itemStyle
            }
          })
          this.labels.push(label)
        })
        let lines = []
        if (this.detailType == '1') {
          lines = [
            { type: '2', label: '终端服务', icon: 'line', show: true },
            { type: '4', label: '终端采购', icon: 'line', show: true },
            { type: '5', label: '销售流向', icon: 'line', show: true },
          ]
        } else if (this.detailType == '2') {
          lines = [
            { type: '1', label: '人员关系', icon: 'line', show: true },
            { type: '4', label: '终端采购', icon: 'line', show: true },
            { type: '5', label: '销售流向', icon: 'line', show: true },
          ]
        } else if (this.detailType == '3') {
          lines = [
            { type: '1', label: '人员关系', icon: 'line', show: true },
            { type: '2', label: '终端服务', icon: 'line', show: true },
            { type: '5', label: '销售流向', icon: 'line', show: true },
          ]
        }
        let info = {}
        lines.map(line => {
          info['data' + line.type] = []
        })
        this.labelsNodes = info
        this.labels = [...this.labels, ...lines]
      }
    },
    getTabs(params, type) {
      let dataIndex = params.dataIndex
      const setSeriesData = (data) => {
        if (data.tabs) {
          let showTab = this.option.series[0].data[dataIndex].showTab
          this.option.series[0].data[dataIndex].showTab = !showTab
          this.tabsVisible = !showTab
        } else {
          let tabs = this.setTabs(data, type)
          this.option.series[0].data[dataIndex].tabs = tabs
          this.option.series[0].data[dataIndex].showTab = true
          this.tabsVisible = true
        }
        this.currNode = this.option.series[0].data[dataIndex]
        // 更新视图
        this.loadChart('full_graph_' + this.chartName, false)
        this.$nextTick(() => {
          this.$emit('openLoading', false)
        })
      }
      if (this.currNode && this.currNode.name == params.data.name) {
        setSeriesData(params.data)
      } else {
        if (params.data.isCenter == 1) {
          setSeriesData(params.data)
        } else {
          let param = { idValue: params.data.name, labelName: params.data.labelName }
          if (this.detailType == '1') {
            param.centerBizId = this.centerId
          }
          getNodeEdge(param).then(res => {
            let data = res.data
            setSeriesData(data)
          })
        }
      }
    },
    getNodes(params, optData, childType) {
      // 设置填充节点
      let optNode = { ...optData }
      if (optNode.isCenter != 1) {
        if (optNode.showChild) {
          optData.label.color = '#fff'
          optData.itemStyle.color = optNode.colors[1]
        } else {
          optData.label.color = optNode.colors[1]
          optData.itemStyle.color = optNode.colors[0]
        }
      }
      getNodeByEdge(params).then(res => {
        let nodes = res.data.nodes, relationship = res.data.relationship
        let data = [], link = []
        // 设置节点
        if (nodes.length) {
          data = this.setDataItem(nodes, optData)
        }
        // 设置关系
        if (relationship.length) {
          relationship.map(item => {
            // if (item.source == optData.name) {
            // 1:人员关系 2:终端服务 3:物流配送 4:终端采购 5:销售流向
            item.label = {
              color: '#8F8F8F',
              formatter: item.displayName
            }
            item.emphasis = {
              disabled: true,
            }
            let type = item.type
            if (type == '1') {
              item.lineStyle = {
                color: '#1890FF'
              }
            } else if (type == '2') {
              item.lineStyle = {
                color: '#4FA1A4'
              }
            } else if (type == '3') {
              // item.lineStyle = {
              //     color: '#1890FF'
              // }
            } else if (type == '4') {
              item.lineStyle = {
                color: '#ED1651'
              }
            } else if (type == '5') {
              item.lineStyle = {
                color: '#4DBF22'
              }
            }
            if (this.showOwn) {
              link.push(item)
            } else {
              let isExist = false, links = [...this.option.series[0].links]
              links.map(ln => {
                if (ln.source == item.source && ln.target == item.target) {
                  isExist = true
                }
              })
              !isExist && link.push(item)
            }

            // }
          })
        }

        let dataChildren = [{
          type: childType,
          data,
          link
        }]
        this.setRestaurants(data)
        if (optData.children) {
          optData.children.push(...dataChildren)
        } else {
          optData.children = dataChildren
        }

        if (!this.showOwn) {
          this.option.series[0].data.push(...data)
          this.option.series[0].links.push(...link)
          // 更新视图
          this.loadChart('full_graph_' + this.chartName, false)
        } else {
          this.loadOwnChart(dataChildren[0], optNode)
        }
        this.$nextTick(() => {
          this.$emit('openLoading', false)
        })
      })
    },
    setNodes(params) {
      this.currNode = params
      let dataIndex = Number(params.seriesId.split('_')[1])
      let seriesIndex = params.seriesIndex
      let options = this.myChart.getOption()
      let selectedMap = options.series[seriesIndex].selectedMap
      let optData = this.option.series[0].data[dataIndex]
      let childType = ''
      nodeStyle.map(node => {
        if (node.tab == params.name) {
          childType = node.type
        }
      })

      // 判断节点数量
      let ownOption = null
      if (Number(params.data.cnt) > Number(this.nodeNum)) {
        this.showOwn = selectedMap[params.name] ? true : false
        if (this.showOwn) {
          this.resultsList = [optData]
          this.closeOwnGraph(false)
        }
        let option = this.myChart.getOption()
        option.series[0].data = [optData]
        option.series[0].links = []
        option.series.splice(1)
        ownOption = option
        let cloneOption = echarts.util.clone(this.option)
        this.ownChartInfo.option = cloneOption
        this.ownChartInfo.restaurants = [optData]
        let nodes = {}
        for (var l in this.labelsNodes) {
          nodes[l] = []
          let tp = l.split('data')[1] + '-'
          if (optData.type && optData.type.indexOf(tp) > -1) {
            nodes[l].push(optData)
          }
        }
        this.ownChartInfo.labelsNodes = nodes
      }

      let children = optData.children ? optData.children : null
      if (children) {
        let childNodes = children.filter(item => item.type == childType)
        if (childNodes.length) { // 节点数据已存在
          let nodeData = childNodes[0].data.filter(cd => cd.showChild)
          if (nodeData.length && !selectedMap[params.name]) return
          if (ownOption == null) {
            let datas = this.arrReduceDelete(childNodes[0].data, this.option.series[0].data)
            let links = this.arrReduceDelete(childNodes[0].link, this.option.series[0].links)
            this.option.series[0].data = datas
            this.option.series[0].links = links
            this.setRestaurants(childNodes[0].data, 'delete')
            if (selectedMap[params.name]) {
              this.$emit('openLoading', true)
              optData.showChild = true
              this.option.series[0].data = [...this.option.series[0].data, ...childNodes[0].data]
              this.option.series[0].links = [...this.option.series[0].links, ...childNodes[0].link]
              this.setRestaurants(childNodes[0].data)
            } else {
              let isShow = false
              for (var s in selectedMap) {
                if (selectedMap[s]) {
                  isShow = true
                }
              }
              if (!isShow) {
                optData.showChild = false
              }
            }
            // 设置填充节点
            let optNode = { ...optData }
            if (optNode.isCenter != 1) {
              if (optNode.showChild) {
                optData.label.color = '#fff'
                optData.itemStyle.color = optNode.colors[1]
              } else {
                optData.label.color = optNode.colors[1]
                optData.itemStyle.color = optNode.colors[0]
              }
            }
            // 更新视图
            this.loadChart('full_graph_' + this.chartName, false)
            this.$emit('openLoading', false)
          } else {
            if (selectedMap[params.name]) {
              this.$emit('openLoading', true)
              this.setRestaurants(childNodes[0].data)
              this.loadOwnChart(childNodes[0], { ...optData })
            }
          }
        } else { // 节点数据不存在
          if (selectedMap[params.name]) {
            this.$emit('openLoading', true)
            if (ownOption == null) {
              optData.showChild = true
            }

            let param = { idValue: optData.name, labelName: optData.labelName, edgeName: params.data.relation }
            if (this.detailType == '1') {
              param.centerBizId = this.centerId
            }
            this.getNodes(param, optData, childType)
          }
        }
      } else {
        if (selectedMap[params.name]) {
          this.$emit('openLoading', true)
          if (ownOption == null) {
            optData.showChild = true
          }
          let param = { idValue: optData.name, labelName: optData.labelName, edgeName: params.data.relation }
          if (this.detailType == '1') {
            param.centerBizId = this.centerId
          }
          this.getNodes(param, optData, childType)
        }
      }
    },
    loadOwnChart(chartData, optNode) {
      this.ownChartInfo.option.series[0].data.push(...chartData.data)
      this.ownChartInfo.option.series[0].links.push(...chartData.link)
      this.$nextTick(() => {
        // let datas = deepClone(this.ownChartInfo.option.series[0].data)
        // let links = deepClone(this.ownChartInfo.option.series[0].links)
        let datas = this.ownChartInfo.option.series[0].data
        let links = this.ownChartInfo.option.series[0].links
        datas[0].showChild = true
        if (optNode.isCenter != 1) {
          datas[0].label.color = '#fff'
          datas[0].itemStyle.color = optNode.colors[1]
        }
        this.$refs['own_graph_' + this.chartName].option.series[0].data = datas
        this.$refs['own_graph_' + this.chartName].option.series[0].links = links
        this.$refs['own_graph_' + this.chartName].labelsNodes = { ...this.ownChartInfo.labelsNodes }
        this.$refs['own_graph_' + this.chartName].loadChart('graph_chart')
        this.$emit('openLoading', false)
      })
    },
    closeOwnGraph(toClose = true) {
      this.labels = this.labels.map(item => { if (item.icon == 'line') { item.show = true } return item })
      this.textAct = false
      this.nodeNum = '10'
      this.isFocus = false
      this.toFocus = true
      this.focusText = '聚焦'
      this.filterKeyword = ''
      this.selectIndex = null
      this.selectNodes = null
      this.selectIndexs = null
      this.resultsList = [...this.restaurants]
      this.toShowFilter = true
      if (toClose) {
        this.showOwn = false
      }
    },
    // 数组 reduce 删除
    arrReduceDelete(originArr, targetArr) {
      let data = originArr.reduce((acc, cur) => {
        let index = null
        let target = acc.find((e, i) => {
          if ((cur.name && e.name == cur.name) || (cur.source && e.source == cur.source && e.target == cur.target)) {
            index = i
            return true
          } else {
            return false
          }
        })
        if (target) {
          acc.splice(index, 1)
        }
        return acc
      }, targetArr)
      return data
    },
    exportData() {
    },
    fullScreen() {
      this.fullVisible = true
      this.$nextTick(() => {
        this.loadChart('full_graph_' + this.chartName)
      })
    },
    changeChart(row) {
      let targetObj = this
      if (this.showOwn) {
        let ownGraph = this.$refs['own_graph_' + this.chartName]
        ownGraph.openLoading(true)
        targetObj = ownGraph
      } else {
        this.$emit('openLoading', true)
      }

      if (targetObj.tabsVisible) {
        targetObj.tabsNodeIndex = null
        targetObj.closeTabs()
      }
      if (row) {
        targetObj.toFocus = false
        if (row.icon && row.icon == 'line') {
          row.show = !row.show
          let nodes = this.setNodesStyle('line', row)
          let datas = nodes.datas
          targetObj.selectIndexs = nodes.dataIndex
          if (row.show) {
            targetObj.option.series[0].data = [...targetObj.option.series[0].data, ...datas]
          } else {
            targetObj.option.series[0].data = datas
          }
        } else if (row == 'changeFocus' || row == 'clear' || row == 'deFocus') {
          if (row == 'clear' || row == 'deFocus') {
            this.selectNodes = null
            this.selectIndex = ''
            this.filterKeyword = ''
          }
          this.focusText = '聚焦'
          this.resultsList = this.showOwn ? [...this.ownChartInfo.restaurants] : [...this.restaurants]
          targetObj.isFocus = false
          targetObj.toFocus = !targetObj.toFocus
          let nodes = this.setNodesStyle('deFocus')
          let datas = nodes.datas
          targetObj.selectIndexs = nodes.dataIndex
          targetObj.option.series[0].data = datas
          if (this.showOwn) {
            targetObj.loadChart('own_graph', false)
            this.$nextTick(() => {
              targetObj.openLoading(false)
            })
          } else {
            this.loadChart('full_graph_' + this.chartName, false)
            this.$nextTick(() => {
              this.$emit('openLoading', false)
            })
          }
        } else {
          this.selectNodes = null
          this.selectIndex = ''
          this.filterKeyword = ''
          this.resultsList = this.showOwn ? [...this.ownChartInfo.restaurants] : [...this.restaurants]
          if (row == 'linksLabel') {
            targetObj.option.series[0].edgeLabel.show = this.textAct
          } else {
            if (row == 'reset') {
              this.textAct = false
              this.nodeNum = '10'
            }
            let nodes = this.setNodesStyle(row)
            let datas = nodes.datas
            targetObj.selectIndexs = nodes.dataIndex
            targetObj.option.series[0].data = datas
          }
          targetObj.isFocus = false
        }
      } else {
        let type = ''
        if (targetObj.toFocus) {
          type = 'toFocus'
          this.focusText = '取消'
          targetObj.isFocus = true
        } else {
          this.selectNodes = null
          this.selectIndex = ''
          this.filterKeyword = ''
          type = 'deFocus'
          this.focusText = '聚焦'
          targetObj.isFocus = false
          this.resultsList = this.showOwn ? [...this.ownChartInfo.restaurants] : [...this.restaurants]
        }
        targetObj.toFocus = !targetObj.toFocus
        let nodes = this.setNodesStyle(type)
        let datas = nodes.datas
        targetObj.selectIndexs = nodes.dataIndex
        targetObj.option.series[0].data = datas
      }
      if (this.showOwn) {
        targetObj.loadChart('own_graph', false)
        this.$nextTick(() => {
          targetObj.openLoading(false)
        })
      } else {
        this.loadChart('full_graph_' + this.chartName, false)
        this.$nextTick(() => {
          this.$emit('openLoading', false)
        })
      }
    },
    setNodesStyle(type, tabType) {
      let series = { ...this.option.series[0] }
      let ownGraph = null
      if (this.showOwn) {
        ownGraph = this.$refs['own_graph_' + this.chartName]
        series = { ...ownGraph.option.series[0] }
      }
      let datas = series.data, dataIndex = []
      let name = this.selectNodes ? this.selectNodes.name : ''
      if (type == 'maxNum' || type == 'reset') {
        datas = [datas[0]]
      } else if (type == 'line') {
        let type = tabType.type, show = tabType.show, nodes = this.showOwn ? ownGraph.labelsNodes['data' + type] : this.labelsNodes['data' + type]
        if (show) {
          let node = []
          nodes.map(item => {
            let isExist = false
            datas.map(dt => {
              if (dt.name == item.name) {
                isExist = true
              }
            })
            !isExist && node.push(item)
          })
          datas = node
          this.setRestaurants(node)
        } else {
          if (this.showOwn) {
            datas = this.arrReduceDelete(nodes, ownGraph.option.series[0].data)
          } else {
            datas = this.arrReduceDelete(nodes, this.option.series[0].data)
          }
          this.setRestaurants(nodes, 'delete')
        }
      } else {
        datas = datas.map((item, i) => {
          if (type == 'toFocus') {
            if (item.name == name) {
              dataIndex.push(i)
            }
          }
          return item
        })
      }
      return { datas, dataIndex }
    },
    chartSelect(row) {
      if (this.selectNodes && row.name == this.selectNodes.name) {
        return
      } else {
        this.filterKeyword = row.nodeName
        this.selectNodes = row
        if (this.showOwn) {
          let ownGraph = this.$refs['own_graph_' + this.chartName]
          if (!ownGraph.toFocus) {
            this.changeChart('changeFocus')
          } else {
            ownGraph.toFocus = true
          }
        } else {
          if (!this.toFocus) {
            this.changeChart('changeFocus')
          } else {
            this.toFocus = true
          }
        }
      }
    },
    querySearch(queryString, cb) {
      var restaurants = this.showOwn ? this.ownChartInfo.restaurants : this.restaurants;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      this.resultsList = results
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.nodeName.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    // 设置筛选列表
    setRestaurants(data, type = 'add') {
      let targetArr = this.restaurants
      if (type == 'delete') {
        let restaurants = data.reduce((acc, cur) => {
          let index = null
          let target = acc.find((e, i) => {
            if (e.name == cur.name) {
              index = i
              return true
            } else {
              return false
            }
          })
          if (target) {
            acc.splice(index, 1)
          }
          return acc
        }, targetArr)

        if (this.showOwn) {
          this.ownChartInfo.restaurants = restaurants
        } else {
          this.restaurants = restaurants
        }
      } else {
        let oldData = this.showOwn ? this.ownChartInfo.restaurants : this.restaurants, newData = []
        data.map(dt => {
          let isExist = oldData.filter(od => dt.name == od.name)
          if (isExist.length == 0) {
            newData.push(dt)
          }
        })

        if (this.showOwn) {
          this.ownChartInfo.restaurants = [...this.ownChartInfo.restaurants, ...newData]
        } else {
          this.restaurants = [...this.restaurants, ...newData]
        }
      }

      this.resultsList = this.showOwn ? [...this.ownChartInfo.restaurants] : [...this.restaurants]
    },
    // 设置筛选列表数据
    setResultsList(data) {
      this.ownChartInfo.restaurants = data
      this.resultsList = data
    }
  }
}
</script>

<style lang="less" scoped>
.chart_warp {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: relative;

  .chart_tool {
    width: 100%;
    position: absolute;
    top: 0;
    z-index: 1;

    /deep/.el-button {
      position: absolute;
      right: 0;

      &.tool_icon_btn {
        right: unset;
        left: 0;
        padding: 0;
        width: 32px;
        height: 32px;

        i {
          font-size: 20px;
        }
      }
    }
  }

  .chart_cont {
    width: 100%;
    height: 100%;
  }

  .empty_tips {
    font-size: 20px;
    color: #909090;
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translateX(-50%);
  }
}

/deep/.el-dialog {
  &__wrapper {
    overflow: hidden;
  }

  &.big_dialog {
    height: 100%;
    margin: 0;

    .el-dialog__header {
      padding: 16px 10px;
      border-bottom: 1px solid #ddd;

      .el-dialog__headerbtn {
        top: 15px;
      }
    }

    .el-dialog__body {
      padding: 0;
      width: 100%;
      height: calc(100% - 57px);
      position: relative;

      .chart_tool {

        .filter_labels {
          width: calc(100% - 60px);
          height: 56px;
          padding-left: 20px;
          background: #fff;
          position: absolute;
          top: -57px;
          left: 0;
          display: flex;
          align-items: center;

          .label_title {
            color: #212121;
            margin-right: 15px;
          }

          .label_item {
            margin-right: 20px;
            display: flex;
            align-items: center;

            &.line {
              margin-left: 60px;

              &+.line {
                margin-left: 0;
              }

              .item_label {
                color: #B2B2B2;
                cursor: pointer;
              }

              &.active {
                .item_icon {
                  &.line {
                    &.bg1 {
                      background-color: #1890FF !important;
                      border-color: #1890FF !important;
                    }

                    &.bg2 {
                      background-color: #4FA1A4 !important;
                      border-color: #4FA1A4 !important;
                    }

                    &.bg3 {
                      background-color: #FF8E35 !important;
                      border-color: #FF8E35 !important;
                    }

                    &.bg4 {
                      background-color: #ED1651 !important;
                      border-color: #ED1651 !important;
                    }

                    &.bg5 {
                      background-color: #4DBF22 !important;
                      border-color: #4DBF22 !important;
                    }
                  }
                }

                .item_label {
                  color: #212121;
                }
              }
            }

            .item_icon {
              display: block;

              &.circle {
                width: 20px;
                height: 20px;
                background: #E7E7E7;
                border: 1px solid #B2B2B2;
                border-radius: 20px;
                margin-right: 10px;
              }

              &.line {
                width: 40px;
                height: 0;
                border: 1px solid #B2B2B2;
                margin-right: 10px;
              }

            }

            .item_label {
              font-size: 14px;
              color: #666;
            }
          }
        }

        .filter_btn {
          position: absolute;
          top: 2.5rem;
          right: 0;
          width: 24px;
          height: 80px;
          background: rgba(0, 0, 0, .5);
          color: #fff;
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          align-items: center;
          transition: all .3s;

          i {
            font-size: 20px;
            margin: 0 2px;
          }
        }

        .filter_panel {
          width: 360px;
          height: calc(100vh - 70px);
          padding-bottom: 10px;
          position: absolute;
          top: 0;
          right: -380px;
          background: #fff;
          box-shadow: 0 4px 10px 0 rgba(0, 0, 0, .2);
          transition: all .3s;

          &.active {
            right: 0;
          }

          .filter_btn {
            width: calc(100% - 30px);
            padding: 15px;
            height: auto;
            position: static;
            background: #fff;
            color: #212121;
            font-size: 16px;
          }

          .filter_bars {
            margin: 10px 15px;

            .bar_item {
              margin-bottom: 5px;
              display: flex;
              align-items: center;
              font-size: 14px;

              .item_label {
                font-size: 14px;
                color: #212121;
                margin-right: 5px;
              }

              .el-switch__label {
                color: #666;
              }

              .el-switch__core {
                height: 16px;

                &::after {
                  width: 14px;
                  height: 14px;
                  top: 0;
                }
              }

              .el-switch.is-checked .el-switch__core::after {
                left: calc(100% + 2px);
              }

              .bar_text {
                display: flex;
                align-items: center;

                .text_txt {
                  color: #666;
                }

                .text_num.el-input {
                  width: 60px;
                  margin: 0 10px;

                  .el-input__inner {
                    height: 24px;
                    line-height: 24px;
                    border-color: #D9D9D9;
                    border-radius: 2px;
                  }
                }
              }
            }
          }

          .inline-input.el-input {
            width: calc(100% - 20px);
            margin: 10px;

            .el-input__inner {
              border-color: #d9d9d9;
              border-radius: 2px 0 0 2px;
              color: #212121;
              font-size: 14px;
              padding-left: 10px;
            }

            .el-input-group__append {
              width: 20px;
              border: 0;

              .auto_btn {
                width: calc(100% - 1px);
                height: calc(100% - 2px);
                background: #d9d9d9;
                color: #666;
                border: 1px solid #d9d9d9;
                border-left: 0;
                border-radius: 0 2px 2px 0;
                position: absolute;
                top: 0;
                left: 0;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 12px;
                cursor: not-allowed;
                transition: all .3s;

                &.active {
                  background-color: #4FA1A4;
                  border-color: #4FA1A4;
                  color: #fff;
                  cursor: pointer;
                }
              }

            }
          }

          .filter_list {
            height: calc(100% - 210px);
            overflow: hidden auto;

            &::-webkit-scrollbar {
              width: 2px;
              height: 4px;
            }

            .list_item {
              height: 36px;
              line-height: 36px;
              padding: 0 15px;
              color: #666;
              cursor: default;
              transition: all .3s;

              &:hover {
                background-color: #F5F5F5;
                color: #212121;
              }

              &.active {
                background-color: #4FA1A4;
                color: #fff;

                &:hover {
                  background-color: #4FA1A4;
                  color: #fff;
                }
              }

            }
          }

          .filter_btns {
            display: flex;
            align-items: center;

            .btn_item {
              width: 50%;
              height: 48px;
              line-height: 48px;
              text-align: center;
              font-size: 14px;
              background-color: #D9D9D9;
              color: #666;
              cursor: pointer;

              &.sure_btn {
                background-color: #4FA1A4;
                color: #fff;
              }
            }
          }
        }
      }

      .tabs_label {
        width: 30px;
        height: 30px;
        color: #fff;
        font-size: 12px;
        border-radius: 100%;
        position: absolute;
        display: flex;
        flex-direction: column;
        align-items: center;
      }
    }
  }
}
</style>
